<div class="col-12">
  @if (articleImages) {
    <swiper-container class="full mb-2" class="image-carousel" init="false" [navigation]="true" [slidesPerView]="1" #swiper [centeredSlides]="true" [centeredSlidesBounds]="true" thumbs-swiper=".mySwiper">
      @for (img of articleImages; track img; let i = $index) {
        <swiper-slide>
          <div class="image-wrapper mx-0 ps-0" style="overflow: hidden">
            <img [src]="img.medium" class="img" [attr.loading]="i === 0 ? 'eager' : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : 'auto'" (click)="openLightBox()"/>
          </div>
        </swiper-slide>
      }
    </swiper-container>
  }
  @if (articleImages.length > 1) {
    <swiper-container
      (swiper)="thumbsSwiper = $event"
      [spaceBetween]="10"
      [slidesPerView]="4"
      [freeMode]="true"
      [watchSlidesProgress]="true"
      class="mySwiper swiper-thumbs mt-1"
      >
      @for (img of articleImages; track img; let i = $index) {
        <swiper-slide
          ><img [src]="img.small" class="img clickable withOpacity" loading="lazy" (click)="gotoImage(img.small)"
        /></swiper-slide>
      }
    </swiper-container>
  }
</div>
